if (!customElements.get('scrolling-banner')) {
  const ScrollingBanner = class extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));

      // Accessible pause/play control (WCAG 2.2.2 Pause, Stop, Hide)
      this.a11yToggle = this.querySelector('[data-a11y-marquee-toggle]');
      if (this.a11yToggle) {
        this.a11yToggle.addEventListener('click', this.toggleA11yPause.bind(this));
      }
    }

    toggleA11yPause() {
      const marquee = this.querySelector('.marquee');
      if (!marquee) return;
      const paused = !this.a11yToggle.classList.contains('is-paused');
      marquee.classList.toggle('marquee--a11y-paused', paused);
      this.a11yToggle.classList.toggle('is-paused', paused);
      this.a11yToggle.setAttribute('aria-label', paused ? 'Play scrolling banner' : 'Pause scrolling banner');
    }

    init() {
      // Transforms can confuse lazy loading in browsers, so we coordinate loading here
      // Load all countdown timers
      customElements.whenDefined('countdown-timer').then(() => {
        this.querySelectorAll('countdown-timer').forEach((el) => el.init());
      });

      // Load all images
      this.querySelectorAll('img[loading="lazy"]').forEach((el) => {
        el.loading = 'eager';
      });

      // After fonts have loaded
      document.fonts.ready.then(() => this.querySelector('.marquee').classList.add('marquee--animate'));
    }
  };

  window.customElements.define('scrolling-banner', ScrollingBanner);
}
